/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { holidaycalendar } from "../../../../../Routes/ImagePath";
import api from "../../../../../api/axios";
import "../../../../../assets/css/employeeDashboard.css";
import Error from "../../../../../assets/img/icons/error2.gif";
import User from "../../../../../assets/img/icons/user3.png";
import { companyID } from "../../../../../auth";
import EditCandidatesModal from "../../../../../components/Administration/Jobs/CandidatesModal/EditCandidatesModal";
import IncompleteProfileModal from "../../../../../components/IncompleteProfileModal";
import config from "../../../../../config";
import {
  calculateTotalAbsentDaysFromMonth,
  calculateTotalPresentDays,
  capitalizeFirstLetter,
  filterAttendanceDates,
  removeHolidays,
  removeWeekends,
} from "../../../../../utils/basicFunctions";
import { encrypt } from "../../../../../utils/crypto";
import {
  formatCustomDate2,
  formatDateTimeInTimezone,
} from "../../../../../utils/formatDateInTimezone";
import { getFile } from "../../../../../utils/getFile";
import Loading from "../../../../../components/Loading";

const EmployeeDashboard = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [fieldOne, setFieldOne] = useState(true);
  const [fieldFour, setFieldFour] = useState(false);
  const [res, setRes] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employeeID, setEmployeeID] = useState();
  const [attendanceData, setAttendanceData] = useState([]);
  const [lossPay, setLossPay] = useState(0);
  const loginEmployeeId = localStorage.getItem("employeeID");
  const encryptedEmployeeId = encrypt(loginEmployeeId);
  const [loading, setLoading] = useState(false);

  // Dashboard data state
  const [dashboardData, setDashboardData] = useState({
    upcomingBirthdays: [],
    upcomingWorkAnniversaries: [],
    upcomingHolidays: [],
    employeeDetails: {},
    incompleteProfile: {},
    leaveBalance: [],
    notification: [],
    leaveApplication: [],
    legancyDataHolidays: [],
    legancyDataWorkingDays: [],
    legancyThisMonthAttendance: [],
    thisMonthAttendance: {},
  });
  useEffect(() => {
    setEmployeeID(loginEmployeeId);
  }, []);

  // Fetch dashboard data
  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const response = await api.get("/api/dashboard");
        if (response?.data?.success) {
          setDashboardData(response.data.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (isEditModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [isEditModalOpen]);

  //---------------------- notifications -------------------------------
  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const response = await api.get(`hr/${loginEmployeeId}/notifications`);
  //       console.log("fetch notification response", response);
  //       setNotificationsData(response?.data?.result?.reverse());
  //     } catch (error) {
  //       console.error("Error fetching notifications:", error);
  //     }
  //   };

  //   fetchNotifications();
  //   const ws = new WebSocket("ws://localhost:8080");

  //   ws.onmessage = (event) => {
  //     console.log("event", event);
  //     const { receiverId, type, message, first_name, last_name, photo, id } =
  //       JSON.parse(event.data);
  //     console.log("websocket notification data:", receiverId, type, message);
  //     if (receiverId == loginEmployeeId) {
  //       console.log("Running,....");
  //       setNotificationsData((prevNotifications) =>
  //         [
  //           ...prevNotifications,
  //           { type, message, first_name, last_name, photo, id },
  //         ].reverse()
  //       );
  //     }
  //     console.log("notification Data", notificationsData);
  //   };

  //   return () => ws.close();
  // }, [loginEmployeeId]);

  function getFirstLetter(string) {
    if (string && typeof string === "string") {
      return string.charAt(0).toUpperCase();
    } else {
      return ""; // Return an empty string if input is not valid
    }
  }
  //------------------------------- Leave Details ------------------------------------
  const [leaveType, setLeaveType] = useState([]);

  const calculateTotalLeaves = (leaveType, leaveBalance) => {
    console.log("leaveType", leaveType); 
    return leaveType.map((leaveType) => {
      const employeeLeave = leaveBalance.find(
        (leave) => leave.leave_type_id === leaveType.id
      );

      if (employeeLeave) {
        return {
          leave_type_id: leaveType.id,
          name: leaveType.name,
          remaining_days: employeeLeave.remaining_days,
          total_remaining_days:
            employeeLeave.remaining_days + employeeLeave.carry_forward_days,
          total_days: leaveType.total_days,
        };
      } else {
        return {
          leave_type_id: leaveType.id,
          name: leaveType.name,
          remaining_days: leaveType.total_days,
          total_remaining_days: leaveType.total_days,
          total_days: leaveType.total_days,
        };
      }
    });
  };

  const totalLeaves = calculateTotalLeaves(
    leaveType,
    dashboardData?.leaveBalance
  );
console.log("totalLeaves", totalLeaves); 
  const totalLeavesCount = totalLeaves.reduce((item, leave) => {
    return item + leave.total_remaining_days;
  }, 0);
  const leaveTaken = totalLeaves.reduce((total, leave) => {
    let balance = leave.total_days - leave.remaining_days;
    return total + balance;
  }, 0);
  console.log("total Leaves", totalLeaves);

  console.log("total Leaves", leaveTaken);

  const current_date = new Date();
  const upcoming_Holiday = dashboardData?.legancyDataHolidays
    .map((holiday) => ({
      ...holiday,
      date: new Date(holiday?.holiday_date),
    }))
    .filter((holiday) => holiday.date > current_date)
    .sort((a, b) => a.date - b.date)[0];

console.log("dashboardData", dashboardData);
  const [leaves, setLeaves] = useState([]);
  const fetchLeaves = async () => {
    try {
      const pending_leaves = dashboardData?.leaveApplication?.filter(
        (item) => item.leave_status == 1
      );
      setLeaves(pending_leaves);
    } catch (err) {
      console.log(err.message);
    }
  };
  useEffect(() => {
    fetchLeaves();
  }, [dashboardData?.leaveApplication]);

  // Auto-open incomplete profile modal if there's an incomplete profile message
  useEffect(() => {
    if (
      dashboardData?.incompleteProfile?.success === false &&
      dashboardData?.incompleteProfile?.message &&
      !isEditModalOpen
    ) {
      setIsModalOpen(true);
    }
  }, [dashboardData?.incompleteProfile, isEditModalOpen]);

  //----------------------------------------- Leave Absent ----------------------------

  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   api
  //     .get(`api/attendance/${loginEmployeeId}`)
  //     .then((res) => {
  //       setData(res.data);
  //     })
  //     .catch((err) => console.error("Error fetching attendance data:", err));
  // }, []);

  useEffect(() => {
    const attendanceOfEmployee = async () => {
      try {
        if (dashboardData?.legancyThisMonthAttendance?.length > 0) {
          const totalAbsentDays = calculateTotalAbsentDaysFromMonth(
            dashboardData?.legancyThisMonthAttendance
          );
          const filterWeekendsdate = removeWeekends(totalAbsentDays);
          setAttendanceData(filterWeekendsdate);
          const filterFromHolidaysData = removeHolidays(
            filterWeekendsdate,
            dashboardData?.legancyDataHolidays || []
          );
          try {
            const filteredAllData = filterAttendanceDates(
              filterFromHolidaysData,
              dashboardData?.leaveApplication || []
            );
            if (filteredAllData.length > 0) {
              setLossPay(filteredAllData?.length);
            }
               console.log("filteredAllDataed", filteredAllData);

          } catch (err) {
            console.log(err);
          }
        }
      } catch (err) {
        console.log("response for attendance data", err);
      }
    };
    attendanceOfEmployee();
  }, [dashboardData]);

  const formatAttendanceValue = (value) => {
    if (value == null || value === "") return 0;
    const num = parseFloat(value);
    if (isNaN(num)) return 0;
    return num;
  };

  if (loading) {
    return <Loading size="lg" variant="dots" text="" />;
  }

  return (
    <>
      {location.pathname.includes("employee-dashboard") && (
        <IncompleteProfileModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
          incompleteProfileNotifier={dashboardData?.incompleteProfile?.message}
          Error={Error}
        />
      )}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid pb-0">
          <div className="row g-4">
            {/* --- WELCOME CARD --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card employee-welcome-card flex-fill">
                <div className="card-body">
                  <div className="welcome-info">
                    <div className="welcome-content">
                      <h4>
                        {t("DashboardPage.Welcome Back")},{" "}
                        {localStorage.getItem("demo_user_name") || (
                          <>
                            {dashboardData.employeeDetails?.first_name &&
                              capitalizeFirstLetter(
                                dashboardData.employeeDetails?.first_name
                              )}{" "}
                            {dashboardData.employeeDetails?.middle_name &&
                              capitalizeFirstLetter(
                                dashboardData.employeeDetails?.middle_name
                              )}{" "}
                            {""}
                            {dashboardData.employeeDetails?.last_name &&
                              capitalizeFirstLetter(
                                dashboardData.employeeDetails?.last_name
                              )}
                          </>
                        )}
                      </h4>
                      {/* <p>
                            You have <span>4 meetings</span> today,
                          </p> */}
                    </div>
                    <div className="welcome-img">
                      <img
                        src={
                          dashboardData.employeeDetails?.photo
                            ? `${config.IMAGE_URL}${dashboardData.employeeDetails?.photo}`
                            : User
                        }
                        className="img-fluid"
                        alt="User"
                      />
                    </div>
                  </div>
                  <div className="welcome-btn">
                    {dashboardData?.incompleteProfile?.success === false &&
                    dashboardData?.incompleteProfile?.message ? (
                      <Link
                        to="#"
                        className="btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setIsEditModalOpen(true);
                        }}
                      >
                        {t("DashboardPage.Edit profile")}
                      </Link>
                    ) : (
                      <Link
                        to={`../employees/profile/${encryptedEmployeeId}`}
                        className="btn"
                      >
                        {t("DashboardPage.View Profile")}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="card info-card flex-fill">
                <div className="card-body">
                  <h4>{t("DashboardPage.Upcoming Holidays")}</h4>
                  <div className="holiday-details">
                    <div className="holiday-calendar">
                      <div className="holiday-calendar-icon">
                        <img src={holidaycalendar} alt="Icon" />
                      </div>
                      <div className="holiday-calendar-content">
                        <h6>{upcoming_Holiday?.occasion}</h6>
                        <p>
                          {" "}
                          {upcoming_Holiday?.date &&
                            formatCustomDate2(upcoming_Holiday?.date)}
                        </p>
                      </div>
                    </div>
                    <div className="holiday-btn">
                      <Link to="../holidays" className="btn">
                        {t("DashboardPage.View All")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* --- ATTENDANCE & LEAVES --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card flex-fill">
                <div className="card-body">
                  <div className="statistic-header">
                    <h4>This Month Attendance</h4>
                  </div>
                  <div className="attendance-list leave-list">
                    <div className="row">
                      <div className="col-6 col-md-4">
                        <div className="attendance-details">
                          <Link to={`../leave-dashboard${loginEmployeeId}`}>
                            <h4 className="text-primary">{formatAttendanceValue(dashboardData?.thisMonthAttendance?.total_leave_days)}</h4>
                            <p style={{ color: "black" }}>
                              Total Leave Days
                            </p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-6 col-md-4">
                        <div className="attendance-details">
                          <Link
                            to={`../leaves-employee/${encryptedEmployeeId}`}
                          >
                            <h4 className="text-pink">{formatAttendanceValue(dashboardData?.thisMonthAttendance?.total_present_days)}</h4>
                            <p style={{ color: "black" }}>
                              Present Days
                            </p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-6 col-md-4">
                        <div className="attendance-details">
                          <Link
                            to={`../attendance-employee/${encryptedEmployeeId}`}
                          >
                            <h4 className="text-success">{formatAttendanceValue(dashboardData?.thisMonthAttendance?.total_absent_days)}</h4>
                            <p style={{ color: "black" }}>
                              Absent Days
                            </p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-6 col-md-6">
                        <div className="attendance-details">
                          <Link
                            to={`../leaves-employee/${encryptedEmployeeId}`}
                          >
                            <h4 className="text-purple">
                              {formatAttendanceValue(dashboardData?.thisMonthAttendance?.total_working_days)}
                            </h4>
                            <p style={{ color: "black" }}>
                              Working Days
                            </p>
                          </Link>
                        </div>
                      </div>
                      <div className="col-6 col-md-6">
                        <div className="attendance-details">
                          <Link
                            to={`../attendance-employee/${encryptedEmployeeId}`}
                          >
                            <h4 className="text-info">
                              {formatAttendanceValue(dashboardData?.thisMonthAttendance?.attendance_percentage)}%
                            </h4>
                            <p style={{ color: "black", whiteSpace: "nowrap" }}>
                              Attendance %
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* --- IMPORTANT NOTIFICATIONS --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card flex-fill h-100">
                <div className="card-body">
                  <div className="statistic-header">
                    <h4>{t("DashboardPage.Important")}</h4>
                  </div>
                  <div className="notification-tab">
                    <ul className="nav nav-tabs">
                      <li>
                        <Link
                          to="#"
                          className="active"
                          data-bs-toggle="tab"
                          data-bs-target="#notification_tab"
                        >
                          <i className="la la-bell" />{" "}
                          {t("DashboardPage.Notifications")}
                        </Link>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane active" id="notification_tab">
                        <div
                          className="employee-noti-content overflow-auto"
                          style={{ maxHeight: "180px" }}
                        >
                          {dashboardData?.notification?.length === 0 && (
                            <h3 className="no-data-text text-center">
                              No Notifications
                            </h3>
                          )}
                          <ul className="employee-notification-list list-unstyled">
                            {dashboardData?.notification?.length > 0 &&
                              dashboardData?.notification?.map(
                                (notification, index) => (
                                  <li
                                    className="employee-notification-grid d-flex align-items-center mb-1"
                                    key={index}
                                  >
                                    <div className="employee-notification-icon me-3">
                                      <Link
                                        to="#"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <span className="badge badge-soft-danger rounded-circle d-flex align-items-center justify-content-center">
                                          {notification?.first_name &&
                                            getFirstLetter(
                                              notification?.first_name
                                            )}
                                          {notification?.last_name &&
                                            getFirstLetter(
                                              notification?.last_name
                                            )}
                                        </span>
                                      </Link>
                                    </div>
                                    <div className="employee-notification-content">
                                      <h6
                                        className="mb-1"
                                        title={notification?.message}
                                      >
                                        <Link
                                          to="#"
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          {notification?.first_name}{" "}
                                          {notification?.last_name}{" "}
                                          {notification?.message}
                                        </Link>
                                      </h6>
                                      <ul className="nav">
                                        <li>
                                          {formatDateTimeInTimezone(
                                            notification?.created_at
                                          )}
                                        </li>
                                      </ul>
                                    </div>
                                  </li>
                                )
                              )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* --- UPCOMING BIRTHDAYS --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100">
                <div style={{ padding: "15px" }}>
                  <h5 className="pb-2">Upcoming Birthdays</h5>
                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {dashboardData?.upcomingBirthdays?.length > 0 ? (
                      dashboardData.upcomingBirthdays.map((person, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-3 p-2 border rounded"
                        >
                          <div className="me-3">
                            {person.photo ? (
                              <img
                                src={config.IMAGE_URL + person.photo}
                                alt={person.first_name}
                                className="rounded-circle"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <div
                                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                style={{ width: "40px", height: "40px" }}
                              >
                                {person.first_name?.[0]}
                                {person.last_name?.[0]}
                              </div>
                            )}
                          </div>

                          <div className="flex-grow-1">
                            <h6>
                              {person.first_name} {person.last_name}
                            </h6>
                            <small className="text-muted">
                              {person.designation_name}
                            </small>
                            <div className="text-primary fw-bold mt-1">
                              {person.days_until_birthday === 0
                                ? "Today!"
                                : person.days_until_birthday === 1
                                ? "Tomorrow"
                                : `${person.days_until_birthday} days`}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted text-center">
                        No upcoming birthdays
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* --- WORK ANNIVERSARIES --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100">
                <div style={{ padding: "15px" }}>
                  <h5 className="pb-2">Work Anniversaries</h5>

                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {dashboardData?.upcomingWorkAnniversaries?.length > 0 ? (
                      dashboardData.upcomingWorkAnniversaries.map(
                        (person, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center mb-3 p-2 border rounded"
                          >
                            <div className="me-3">
                              {person.photo ? (
                                <img
                                  src={getFile(person.photo)}
                                  alt={person.first_name}
                                  className="rounded-circle"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                                  style={{ width: "40px", height: "40px" }}
                                >
                                  {person.first_name?.[0]}
                                  {person.last_name?.[0]}
                                </div>
                              )}
                            </div>

                            <div className="flex-grow-1">
                              <h6>
                                {person.first_name} {person.last_name}
                              </h6>
                              <small className="text-muted">
                                {person.designation_name}
                              </small>

                              <div className="d-flex justify-content-between mt-1">
                                <span className="badge bg-success">
                                  {person.years_completed} Years
                                </span>
                                <small className="fw-bold text-success">
                                  {person.days_until_anniversary === 0
                                    ? "Today!"
                                    : person.days_until_anniversary === 1
                                    ? "Tomorrow"
                                    : `${person.days_until_anniversary} days`}
                                </small>
                              </div>
                            </div>
                          </div>
                        )
                      )
                    ) : (
                      <p className="text-muted text-center">
                        No upcoming anniversaries
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* --- UPCOMING HOLIDAYS (LARGE VERSION) --- */}
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100">
                <div style={{ padding: "15px" }}>
                  <h5 className="pb-2">Upcoming Holidays</h5>

                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {dashboardData?.upcomingHolidays?.length > 0 ? (
                      dashboardData.upcomingHolidays.map((holiday, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-3 p-3 border rounded bg-light"
                        >
                          <div className="me-3">
                            <div
                              className="rounded-circle bg-warning text-white d-flex align-items-center justify-content-center"
                              style={{ width: "50px", height: "50px" }}
                            >
                              <i
                                className="fa fa-gift"
                                style={{ fontSize: "20px" }}
                              ></i>
                            </div>
                          </div>

                          <div className="flex-grow-1">
                            <h6 className="mb-1 text-dark">
                              {holiday.occasion}
                            </h6>

                            <p className="text-muted small">
                              {new Date(
                                holiday.holiday_date
                              ).toLocaleDateString("en-US", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </p>

                            <div className="text-warning fw-bold">
                              {holiday.days_until_holiday === 0
                                ? "Today!"
                                : holiday.days_until_holiday === 1
                                ? "Tomorrow"
                                : `${holiday.days_until_holiday} days away`}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted text-center">
                        No upcoming holidays
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isEditModalOpen && (
            <EditCandidatesModal
              employID={loginEmployeeId}
              fieldFour={fieldFour}
              setFieldFour={setFieldFour}
              fieldOne={fieldOne}
              setFieldOne={setFieldOne}
              res={res}
              isEditModalOpen={isEditModalOpen}
              setIsEditModalOpen={setIsEditModalOpen}
            />
          )}
        </div>
        {/* /Page Content */}
        {isEditModalOpen && <div className="modal-backdrop fade show"></div>}
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default EmployeeDashboard;
